import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

export function useGlobalSearch(query, scope = null) {
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!query || query.trim().length === 0) {
      setResults([]);
      return;
    }

    const abortController = new AbortController();

    const fetchResults = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const queryParams = new URLSearchParams({ q: query });
        if (scope) {
          queryParams.append('scope', scope);
        }
        const endpoint = `/search?${queryParams.toString()}`;
        
        const response = await apiFetch(endpoint, null, {
          method: 'GET',
          signal: abortController.signal
        });
        
        setResults(response?.results || []);
      } catch (err) {
        if (err.name === 'CanceledError' || err.name === 'AbortError') return;
        console.error('Search error:', err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    const debounceTimer = setTimeout(() => {
      fetchResults();
    }, 300);

    return () => {
      clearTimeout(debounceTimer);
      abortController.abort();
    };
  }, [query, scope]);

  return { results, isLoading, error };
}
